// extracted by mini-css-extract-plugin
export var lg = "_2v-4";
export var md = "_2v-3";
export var sm = "_2v-2";
export var xs = "_2v-1";
export var xxs = "_2v-0";